import { Navigate } from 'react-router-dom';
import { Flow_Types } from '@occc-app/offerHelpers/types';
import { OfferUpdatePage } from './OfferUpdatePage';
import { OfferConfigurePageContainerProps } from './types';

import { useGetContainerProps } from '../hooks/useGetContainerProps';

export const OfferUpdatePageContainer = ({
  campaignId,
  offerId,
  offerType,
  pageTitle,
  getBreadcrumbLinks,
  subtitle,
  ConfigureFormContainer,
  isDesignTabHidden = false,
  targetTabProps,
  ignoreConfigureFormSubmit = false,
  showExternalUrl = false,
  showSurgeonGeneralsWarning = true,
  getIsOrderAheadEnabled,
  finallyRedirectTo,
  redirects,
}: OfferConfigurePageContainerProps) => {
  const { layoutProps, initialFormProps, scheduleFormProps, formContainersProps, dialogProps } =
    useGetContainerProps({
      campaignId,
      offerId,
      offerType,
      flowType: Flow_Types.Update,
      getBreadcrumbLinks,
      ignoreConfigureFormSubmit,
      getIsOrderAheadEnabled,
      finallyRedirectTo,
    });

  const redirectRequired = redirects?.find(({ when }) =>
    when({ offer: formContainersProps.offer }),
  );
  if (redirectRequired) {
    return <Navigate to={redirectRequired.to} replace />;
  }

  return (
    <OfferUpdatePage
      pageTitle={pageTitle}
      subtitle={subtitle}
      layoutProps={layoutProps}
      dialogProps={dialogProps}
      initialFormProps={initialFormProps}
      scheduleFormProps={scheduleFormProps}
      formContainersProps={formContainersProps}
      configureForm={
        ConfigureFormContainer ? <ConfigureFormContainer {...formContainersProps} /> : undefined
      }
      isDesignTabHidden={isDesignTabHidden}
      targetTabProps={targetTabProps}
      showExternalUrl={showExternalUrl}
      showSurgeonGeneralsWarning={showSurgeonGeneralsWarning}
    />
  );
};
